import React, { Component } from "react";
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";


import TYDropDownItem from "./item";
import TYDropDownSeparator from "./separator";


export default class TYDropDown extends Component{
    constructor(props){
        super(props);
        this.state = {
            shown: false
        };
    }

    componentWillMount() {
        document.addEventListener('click', this.handleDocClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocClick, false);
    }

    handleDocClick = e => {
        if(!ReactDOM.findDOMNode(this).contains(e.target)) {
            if(this.state.shown)
                this.setState({shown: false});
        }
    };

    toggle = () => {
        this.setState({ shown: !this.state.shown });
    };

    render(){
        let {
            label,
            color,
            disabled,
            outline,
            shadowed,
            size,
            children,
            ...props
        } = this.props;

        return (
            <div className={
                "dropdown-container"
                + (shadowed ? " dropdown-shadowed" : "")
            }>
                <div
                    onClick={ this.toggle }
                    className={
                        "dropdown-btn"
                    }
                    {...props}
                >
                    { label }

                    <i className={"icon-chevron-" + ( this.state.shown ? "up" : "down") + " dropdown-chevron"} />
                </div>

                {
                    this.state.shown ?
                        <div className="dropdown-items-container">
                            { children }
                        </div>
                        : null
                }
            </div>
        );
    }
}

TYDropDown.propTypes = {
    label: PropTypes.string
};

TYDropDown.defaultProps = {
    label: "Choisir ..."
};

export {
    TYDropDownItem,
    TYDropDownSeparator
};



// WEBPACK FOOTER //
// ./src/components/TYDropDown/index.js